import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Typography,
  Container,
  Grid,
  Box,
  TextField,
  IconButton,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Search, Add, FilterList } from "@mui/icons-material";
import LeadCard from "./LeadCard";
import Select from "react-select";
import axios from "axios";
import { getCategory } from "./Master/Category/getEditCategory";

const LeadsBoard = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(null);
  const [filter, setFilter] = React.useState(null);

  const [newLeads, setNewLeads] = useState([]);
  const [hotLeads, setHotLeads] = useState([]);
  const [coldLeads, setColdLeads] = useState([]);
  const [warmLeads, setWarmLeads] = useState([]);

  const [columns, setColumns] = useState([
    { name: "New", leads: [] },
    { name: "Hot", leads: [] },
    { name: "Cold", leads: [] },
    { name: "Warm", leads: [] },
    { name: "Lost", leads: [] },
  ]);

  const handleCategory = (selectedOption) => {
    console.log(selectedOption, "category");
    getleadsData(selectedOption.value);
    setCategory(selectedOption);
  };

  const handleFilterChange = (selectedOption) => {
    setFilter(selectedOption);
  };

  const filterOptions = [
    { value: "", label: "None" },
    { value: 10, label: "Filter 1" },
    { value: 20, label: "Filter 2" },
    { value: 30, label: "Filter 3" },
  ];

  async function getleadsData(category) {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/getleads/${category}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await axios.get(url, config).then((response) => {
      if (response.data && response.data.isSuccess) {
        const { newleads, hotLeads, coldLeads, warmLeads } =
          response.data.result;
        setColumns([
          { name: "New", leads: newleads },
          { name: "Hot", leads: hotLeads },
          { name: "Cold", leads: coldLeads },
          { name: "Warm", leads: warmLeads },
          { name: "Lost", leads: [] },
        ]);
      }
    });
  }
  useEffect(() => {
    const fetchCategories = async () => {
      const categoryData = await getCategory();
      if (categoryData) {
        const formatteData = categoryData.result.map((item) => ({
          label: item.category_name,
          value: item.id,
        }));
        setCategories(formatteData);
        setCategory(formatteData[1]);
        getleadsData(formatteData[1].value);
      }
    };
    fetchCategories();
  }, []);

  return (
    <Container
      component="main"
      maxWidth="xl"
      sx={{
        bgcolor: "background.paper",
        borderRadius: 1,
        paddingTop: 2,
        paddingBottom: 2,
      }}
    >
      <Box sx={{ mb: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 1,
            mt: 1,
          }}
        >
          <Typography variant="h5" color="textSecondary">
            Leads
          </Typography>
          <Box>
            <Button
              variant="outlined"
              color="primary"
              sx={{
                width: 150,
                height: 35,
                fontSize: 14,
                borderRadius: 2,
                m: 1,
              }}
              onClick={() => console.log("Create")}
            >
              Create Leads
            </Button>
            <Button
              variant="outlined"
              color="primary"
              sx={{ width: 70, height: 35, fontSize: 14, borderRadius: 2 }}
              onClick={() => navigate(-1)}
            >
              BACK
            </Button>
          </Box>
        </Box>
        <Box>
          <Box display="flex" justifyContent="space-between" mt={2}>
            <TextField
              variant="outlined"
              placeholder="Search"
              size="small"
              sx={{ width: 200 }}
              InputProps={{
                endAdornment: (
                  <IconButton>
                    <Search />
                  </IconButton>
                ),
              }}
            />
            <Box display="flex" alignItems="center">
              <FormControl
                variant="outlined"
                size="small"
                sx={{ mr: 2, minWidth: 200 }}
              >
                <Select
                  value={category}
                  onChange={handleCategory}
                  options={categories}
                  placeholder="Select Category"
                />
              </FormControl>
              <FormControl
                variant="outlined"
                size="small"
                sx={{ mr: 2, minWidth: 200 }}
              >
                <Select
                  value={filter}
                  onChange={handleFilterChange}
                  options={filterOptions}
                  placeholder="Filter"
                />
              </FormControl>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ overflowX: "auto", whiteSpace: "nowrap" }}>
        <Grid container spacing={2} sx={{ flexWrap: "nowrap" }}>
          {columns.map((column, index) => (
            <Grid
              item
              key={index}
              xs={12}
              sx={{ display: "inline-block", minWidth: 500 }}
            >
              <Card variant="outlined" sx={{ mb: 2, width: "100%" }}>
                <CardContent>
                  <Typography variant="h6" align="center">
                    {column.name}
                  </Typography>
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    sx={{ mb: 2 }}
                  >
                    Create Lead
                  </Button>
                  {column.leads.map((lead, leadIndex) => (
                    <LeadCard key={leadIndex} lead={lead} />
                  ))}
                  {column.leads.length === 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: 150,
                      }}
                    >
                      <Typography color="textSecondary">No Lead</Typography>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default LeadsBoard;
